import { MapPin } from 'lucide-react';
import { PlusCodeBadge } from './PlusCodeBadge';

interface AddressDisplayProps {
  addressDisplay?: string | null;
  address: string;
  island: string;
  plusCode?: string | null;
  compact?: boolean;
}

export function AddressDisplay({
  addressDisplay,
  address,
  island,
  plusCode,
  compact = false,
}: AddressDisplayProps) {
  const displayAddress = addressDisplay || `${address} · ${island}`;

  if (compact) {
    return (
      <div className="flex items-start gap-1.5" data-testid="address-display">
        <MapPin className="h-4 w-4 flex-shrink-0 text-primary/50 mt-0.5" />
        <div className="min-w-0">
          <p className="text-gray-500 text-sm truncate">{displayAddress}</p>
          {!addressDisplay && (
            <p className="text-gray-400 text-xs sm:hidden">{island}</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2" data-testid="address-display">
      <div className="flex items-start gap-1.5">
        <MapPin className="h-4 w-4 flex-shrink-0 text-primary/50 mt-0.5" />
        <div>
          <p className="text-gray-500">{displayAddress}</p>
          {addressDisplay && (
            <p className="text-gray-400 text-sm">{island}</p>
          )}
        </div>
      </div>
      {plusCode && (
        <div className="ml-[22px]">
          <PlusCodeBadge plusCode={plusCode} />
        </div>
      )}
    </div>
  );
}
